import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 27,
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 26,
			height: 26,
			rx: 13,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 26,
			height: 26,
			rx: 13,
			stroke: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0062 8.4375H12.9937V12.9937H8.4375V14.0062H12.9937V18.5625H14.0062V14.0062H18.5625V12.9937H14.0062V8.4375Z",
			fill: "#395566"
		})
	]
});
export default SvgLine;
